import React, { useEffect, useState, useCallback } from 'react'

// react meta tags
import MetaTags, { ReactTitle } from 'react-meta-tags';

// react redux
import { connect } from "react-redux";

// custom hooks
import useQueryHook from 'utlis/CustomHooks/useQueryHook';

// react toastify
import { toast } from "react-toastify";

// APIs 
// products
import { getProducts, cancelGetProductsApi } from "utlis/Apis/Products_API";

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE_FETCHING_PRODUCTS,
} from "utlis/AppMessages/AppMessages";

// themes
import Theme1 from './themes/Theme1'

function Shop(props) {
    // props
    const {
        globalAppTheme,
        commonToken,
        match,

        location
    } = props

    // consts
    const query = useQueryHook()

    // states
    const [categoryId, setCategoryId] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentSort, setCurrentSort] = useState("");

    const [allProductsLoading, setAllProductsLoading] = useState(false);
    const [allProducts, setAllProducts] = useState([]);
    const [allProductsImages, setAllProductsImages] = useState([]);
    const [currentRoute, setCurrentRoute] = useState({}); // { routeName: 'name of the route', routeUrl: 'url of the route' }

    const [paginationLinks, setPaginationLinks] = useState([])

    const [filtersList, setFiltersList] = useState([])
    const [appliedFilters, setAppliedFilters] = useState([])
    const [metaTitleName, setMetaTitleName] = useState("")

    // setting category id
    useEffect(() => {
        const catId = query.get('id')
        const page = query.get('page')
        const sort = query.get('sort')

        if (catId) { // setting category id if exist
            setCategoryId(catId)
        }

        if (page) {  // setting page if exist
            // setting page
            setCurrentPage(page)
        } else {
            // setting page
            setCurrentPage(1)
        }

        if (sort) {  // setting sort by if exist
            // setting page
            setCurrentSort(sort)
        } else {
            // setting page
            setCurrentSort("")
        }
    }, [query])

    // function to get categories
    const getProductsByCategory = useCallback(() => {
        if (categoryId) {
            const isSortOrderExist = currentSort ? `&sort=${currentSort}` : ""

            const URLParams = `category_id=${categoryId}&page=${currentPage}&limit=12${isSortOrderExist}`;

            // scroll the page to the top
            window.scrollTo(0, 0);

            // getting data
            getProducts(commonToken ?? "", URLParams).then(res => {
                const resData = res?.data;

                // disabling loading
                setAllProductsLoading(false);

                // scroll the page to the top
                window.scrollTo(0, 0);

                // if request succesfull
                if (resData?.success) {
                    setAllProducts(resData.data);
                    // product images
                    setAllProductsImages(resData.images);

                    // setting pagination links
                    setPaginationLinks(resData.links)

                    if (resData?.filters) {
                        const filters = resData?.filters

                        const filtersData = []
                        for (const key in filters) {
                            filtersData.push({
                                name: key.toLowerCase(),
                                values: filters[key]
                            })
                        }
                        // setting filters data
                        setFiltersList(filtersData)
                    }
                }

                // if request is not succesfull
                if (resData?.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_FETCHING_PRODUCTS, {
                        autoClose: 3000,
                        onClose: () => { },
                    });
                }
            }).catch((err) => {
                console.log(`${ERROR_WHILE__NAME} getProducts `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // disabling loading
                        setAllProductsLoading(false);
                    },
                });
            });
        }
    }, [
        categoryId,
        currentPage,
        commonToken,
        currentSort
    ]);

    // getting products
    useEffect(() => {
        // enabling loading
        setAllProductsLoading(true);

        getProductsByCategory(); // getting product 

        return () => {
            cancelGetProductsApi && cancelGetProductsApi()
        }
    }, [getProductsByCategory]);

    // breadcrumbs generating
    useEffect(() => {
        if (match?.params?.catName) {
            const catName = match?.params?.catName

            // setting current route
            setCurrentRoute({
                routeName: catName.replaceAll("-", " ").toUpperCase(),
                sku: catName,
                routeUrl: "/shop/" + catName + "?id=" + categoryId,
            });

            setMetaTitleName(catName.replaceAll("-", " ").toUpperCase() + " | Ruhlistic Decor")
        }
    }, [match, categoryId]);

    // remove single filter
    const onFilterChangeTriggered = ev => {
        ev.preventDefault()
    }

    // remove single filter
    const handleRemoveFilter = (ev, id) => {
        ev.preventDefault()

        console.log("id ", id);
    }

    // remove all filters
    const handleResetAllFilters = ev => {
        ev.preventDefault()
    }

    return (
        <React.Fragment>
            {/* <MetaTags>
                <title>{metaTitleName} | Ruhlistic Decor</title>
                <meta name="description" content="Ruhlistic Decor's unexampled collection of home decor, eccentric accessories, stylish furniture and outdoor living accents make us a one stop shop for all your design needs. Check out our website today!" />
                <meta name="keywords" content="home decor, candles, candleholders, Glass vases, modern decor, modern furniture, wedding decor, pots, planters, furniture" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={`${metaTitleName} | Ruhlistic Decor`} />
                <meta property="og:description" content="Ruhlistic Decor's unexampled collection of home decor, eccentric accessories, stylish furniture and outdoor living accents make us a one stop shop for all your design needs. Check out our website today!" />
                <meta property="og:url" content="https://www.ruhlisticdecor.com" />
                <meta property="og:site_name" content="Ruhlistic Decor" />
                <meta property='og:image' content="https://www.ruhlisticdecor.com/images/logo.png" name="og_image" />
                <meta property="og:image:alt" content={`${metaTitleName} | Ruhlistic Decor`} />
                <meta property='og:image:secure_url' content="https://www.ruhlisticdecor.com/images/logo.png" />
                <meta name="twitter:card" content="summary" />
                <meta name="twitter:description" content="Ruhlistic Decor's unexampled collection of home decor, eccentric accessories, stylish furniture and outdoor living accents make us a one stop shop for all your design needs. Check out our website today!" />
                <meta name="twitter:title" content={`${metaTitleName} | Ruhlistic Decor`} />
                <meta name="twitter:image" content="https://www.ruhlisticdecor.com/images/logo.png" />
            </MetaTags> */}
            <ReactTitle title={metaTitleName} />

            {
                globalAppTheme === 'theme1' ? (
                    <Theme1
                        allProductsLoading={allProductsLoading}
                        allProducts={allProducts}
                        allProductsImages={allProductsImages}

                        currentRoute={currentRoute}

                        categoryId={categoryId}
                        currentPath={location.pathname}
                        paginationLinks={paginationLinks}

                        onFilterChangeTriggered={onFilterChangeTriggered}
                        handleRemoveFilter={(ev, id) => handleRemoveFilter(ev, id)}
                        handleResetAllFilters={handleResetAllFilters}

                        filtersList={filtersList}
                        appliedFilters={appliedFilters}
                    />
                ) : null
            }
        </React.Fragment>
    )
}

const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
        commonToken: state.auth.commonToken,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {

    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(Shop);